'use client';

import H3 from '@/components/typography/h3';
import P from '@/components/typography/p';
import { useEffect, useRef } from 'react';

type PrServiceItem = {
    title: string;
    description: string;
};

interface PrServiceCardMobiProps {
    item: PrServiceItem;
    index: number;
    activeIndex: number;
    setActiveIndex: (index: number) => void;
}

export default function PrServiceCardMobi({
    item,
    index,
    activeIndex,
    setActiveIndex,
}: PrServiceCardMobiProps) {
    const cardRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleScroll = () => {
            if (!cardRef.current) return;

            const rect = cardRef.current.getBoundingClientRect();
            const cardMid = rect.top + rect.height / 2;
            const viewportMid = window.innerHeight / 2;

            const isCentered =
                Math.abs(cardMid - viewportMid) < rect.height / 2;

            if (isCentered) {
                setActiveIndex(index);
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll();

        return () => window.removeEventListener('scroll', handleScroll);
    }, [index, setActiveIndex]);

    const isActive = activeIndex === index;

    return (
        <div
            ref={cardRef}
            className={`flex flex-col gap-[1.87rem] rounded-lg px-[1.4rem] pt-[1.25rem] pb-[2rem] transition-colors duration-300 ${
                isActive
                    ? 'border border-transparent bg-[oklch(0.8141_0.0822_302.25)]'
                    : 'border-primary border'
            }`}
        >
            <H3>{item.title}</H3>
            <P>{item.description}</P>
        </div>
    );
}
